import { render, staticRenderFns } from "./order-profit-rate-list.vue?vue&type=template&id=2e74e65a&scoped=true&"
import script from "./order-profit-rate-list.vue?vue&type=script&lang=js&"
export * from "./order-profit-rate-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74e65a",
  null
  
)

export default component.exports